import { useRestApi } from '@/components/Common/useRestApi';
import { AuthService } from '@/services/api/auth.service';
import { Ref } from 'vue';

interface RespType {
  isLoading: Ref<boolean>;
  data: Ref<unknown>;
  error: Ref<null>;
  makeAPICall: (params: any) => Promise<void>;
}

export interface SelectFieldOption {
  label: string;
  value: string;
}

interface DataResp {
  teams: Array<SelectFieldOption>;
  total: number;
}

const formatFunc = (resp) => {
  let teams = resp?.data?.teams?.map((obj) => ({
    label: obj?.name,
    value: obj?.id,
  }));

  return {
    teams,
    total: resp?.data?.total,
  };
};

export function useGetTeamsData() {
  const { isLoading, data, error, makeAPICall }: RespType = useRestApi(
    AuthService.getTeamsList,
    formatFunc,
  );

  const fetchTeamsList = (pageNo, keyword) => {
    makeAPICall({ pageNo, pageSize: 10, keyword });
  };

  return {
    isLoading,
    data: data as Ref<DataResp>,
    error,
    fetchTeamsList,
  };
}
